module.exports = __webpack_public_path__ + "static/media/CoinGecko.0badb6d1.png";